import { Component, OnInit, Input, OnDestroy, ChangeDetectionStrategy, ViewChild, ElementRef } from '@angular/core';
import { FeatureModel } from '../../../@core/models/feature.model';
import { Subscription } from 'rxjs';
import { DataService } from '../../../@core/services/data.service';
import { FeaturesRowInterface } from '../../../@core/models/site-data.model';
import { FontsService } from 'src/app/@core/services/fonts.service';

@Component({
  selector: 'app-features-images',
  templateUrl: './features-images.component.html',
  styleUrls: ['./features-images.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MatrialFeaturesImagesComponent implements OnInit {

  title: string;
  titleSize: string;
  titleInputValue: string;
  fontWeight: string;
  features: FeatureModel[];
  subscription: Subscription;
  backgroundColor: string;
  data: FeaturesRowInterface;
  active: boolean = false;
  activatePadding: boolean = false;
  position: number = 0;
  moduleInfo: string;
  siteId: string = '';
  email: string = '';
  titleColor: string;
  textColor: string;
  componentsNames: string = '';
  titleFontFamily: string;
  titleFontFamilyName: string;

  constructor(private dataService: DataService,private fontsService:FontsService) {
    this.componentsNames = this.dataService.getComponentsNames('FeaturesRow').join(' ');
    this.email = JSON.parse(localStorage.getItem('userData')) ? JSON.parse(localStorage.getItem('userData')).email : '';
  }

  ngOnInit() {
    this.dataService.getSiteId().subscribe(siteId => {
      this.siteId = siteId;
    });
    this.moduleInfo = JSON.stringify({ position: this.position, new: false });
    this.title = this.data.title;
    this.titleSize = this.data.titleSize ? this.data.titleSize : '';
    this.backgroundColor = this.data.backgroundColor ? this.data.backgroundColor : '';
    this.titleInputValue = this.data.title;
    this.fontWeight = this.data.fontWeight ? this.data.fontWeight : '400';
    this.features = this.data.features;
    this.titleColor = this.data.titleColor ? this.data.titleColor : this.dataService.getDefaultColor(this.backgroundColor);
    this.titleFontFamily = this.data.titleFontFamily ? this.data.titleFontFamily : '';
    if(this.titleFontFamily){
      this.fontsService.AddFont(this.titleFontFamily);
      this.titleFontFamilyName = this.titleFontFamily.replace(/\+/g, " ")
    }
  }
  
  getTitleFontFamilyName(titleFontFamily:string){
    if(titleFontFamily){
      this.fontsService.AddFont(titleFontFamily);
    }
    return titleFontFamily ? titleFontFamily.replace(/\+/g, " ") : '';
  }

}
